import { IProfile } from 'src/app/_models/account/IProfile';
import { ProfileService } from './../../../../shared/services/profile.service';
import { EditorConfigService } from './../../../../shared/services/angular-editor.service';
import { ITransferOrder } from './../../../../_models/transfer-sections/ITransferOrder';
import { ISetting } from './../../../../_models/cms/ISetting';
import { SettingService } from './../../../../shared/services/setting.service';
import { IKeyValuePair } from './../../../../_models/common/common';
import { CommonService } from './../../../../shared/services/common.service';
import { TransferOrderService } from '../../../../shared/services/transfer-order.service';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'app-transfer-order-form',
  templateUrl: './transfer-order-form.component.html'
})
export class TransferOrderFormComponent implements OnInit {
  year: number = new Date().getFullYear();
  skeleton: boolean = true;
  loading: boolean;
  title: string = 'Add Transfer Order';
  transferOrder: ITransferOrder;
  transferOrderForm: FormGroup;
  id;
  profileId;
  profile: IProfile;

  schoolLevels: IKeyValuePair[];
  regions: IKeyValuePair[];
  toStates: IKeyValuePair[];
  toDistricts: IKeyValuePair[];
  toSchools: IKeyValuePair[];
  designations: IKeyValuePair[];

  fromStates: IKeyValuePair[];
  fromDistricts: IKeyValuePair[];
  fromSchools: IKeyValuePair[];
  transferCategories: IKeyValuePair[];

  setting: ISetting;
  editorConfigOption: AngularEditorConfig;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private toastrService: ToastrService,
    private service: TransferOrderService,
    private commonService: CommonService,
    private settingService: SettingService,
    private profileService: ProfileService,
    private editorConfigService: EditorConfigService) {
    this.id = this.route.snapshot.paramMap.get('id');
    this.profileId = this.route.snapshot.paramMap.get('profileId');
  }

  async ngOnInit() {
    this.editorConfigOption = this.editorConfigService.getOption();
    this.createTransferOrderForm();

    this.setting = await this.settingService.getSetting();

    this.bindDropDown();
    this.getTransferOrder();

    this.skeleton = false;
  }


  private getTransferOrder() {
    if (this.id)
    {
      this.service.get(this.id).subscribe((response: ITransferOrder) => {
        if (response) {
          this.transferOrder = response;
          this.profile = response.profile;
          this.title = 'Edit Transfer Order';
          this.setValueTransferOrderForm();
        }
      });
    }
    else
    {
      this.profileService.get(this.profileId).subscribe((response: IProfile) => {
        if (response) {
          this.profile = response;
          this.transferOrderForm.patchValue({
            profileId: this.profileId
          });
        }
      });
    }
      
  }

  bindDropDown() {

    this.commonService.getSchoolLevels().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.schoolLevels = response;
      }
    });

    this.commonService.getRegions().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.regions = response;
      }
    });

    this.commonService.getDesignations().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.designations = response;
      }
    });

    this.commonService.getTransferCategories().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.transferCategories = response;
      }
    });
  }

  changeDepartment(value, isTo: boolean = false) {
    if (value != 1) {
      this.getSchools(null, value);
    }
  }

  getStates(regionId: string, isTo: boolean = false) {
    this.commonService.getStates(regionId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        if (isTo)
          this.toStates = response;
        else
          this.fromStates = response;
      }
    });
  }

  getDistricts(stateId: number, isTo: boolean = false) {
    this.commonService.getDistricts(stateId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        if (isTo)
          this.toDistricts = response;
        else
          this.fromDistricts = response;
      }
    });
  }

  getSchools(districtId: number, schoolLevelId?: number, isTo: boolean = false) {
    this.commonService.getSchools(districtId, schoolLevelId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        if (isTo)
          this.toSchools = response;
        else
          this.fromSchools = response;
      }
    });
  }

  createTransferOrderForm() {
    this.transferOrderForm = this.fb.group({
      id: ['0'],
      profileId: [''],
      fromSchoolLevelId: ['', Validators.required],
      fromRegionId: [''],
      fromStateId: [''],
      fromDistrictId: [''],
      fromSchoolId: ['', Validators.required],
      fromDesignationId: ['', Validators.required],
      
      toSchoolLevelId: ['', Validators.required],
      toRegionId: [''],
      toStateId: [''],
      toDistrictId: [''],
      toSchoolId: ['', Validators.required],
      toDesignationId: ['', Validators.required],
      orderNo: ['', Validators.required],
      orderDate: ['', [Validators.required, Validators.pattern("[0-9]{2}[-][0-9]{2}[-][0-9]{4}")]],
      transferCategoryId: ['', Validators.required],
      remark: [''],
      remark1: [''],
      cumulativeCountAdd: [false],
      cumulativeCountPrev: [false]
    });
  }

  setValueTransferOrderForm() {

    if (this.transferOrder.fromSchool.regionId) {
      this.getStates(this.transferOrder.fromSchool.regionId);
    }

    if (this.transferOrder.fromSchool.stateId) {
      this.getDistricts(this.transferOrder.fromSchool.stateId);
    }

    if (this.transferOrder.fromSchool.districtId || this.transferOrder.fromSchool.schoolLevelId) {
      this.getSchools(this.transferOrder.fromSchool.districtId, this.transferOrder.fromSchool.schoolLevelId);
    }

    
    if (this.transferOrder.toSchool.regionId) {
      this.getStates(this.transferOrder.toSchool.regionId, true);
    }

    if (this.transferOrder.toSchool.stateId) {
      this.getDistricts(this.transferOrder.toSchool.stateId, true);
    }

    if (this.transferOrder.toSchool.districtId || this.transferOrder.toSchool.schoolLevelId) {
      this.getSchools(this.transferOrder.toSchool.districtId, this.transferOrder.toSchool.schoolLevelId, true);
    }

    this.transferOrderForm.patchValue({
      id: this.transferOrder.id,
      profileId: this.transferOrder.profileId,
      fromSchoolLevelId: this.transferOrder.fromSchool.schoolLevelId,
      fromRegionId: this.transferOrder.fromSchool.regionId,
      fromStateId: this.transferOrder.fromSchool.stateId,
      fromDistrictId: this.transferOrder.fromSchool.districtId,
      fromSchoolId: this.transferOrder.fromSchoolId,
      fromDesignationId: this.transferOrder.fromDesignationId,
      toSchoolLevelId: this.transferOrder.toSchool.schoolLevelId,
      toRegionId: this.transferOrder.toSchool.regionId,
      toStateId: this.transferOrder.toSchool.stateId,
      toDistrictId: this.transferOrder.toSchool.districtId,
      toSchoolId: this.transferOrder.toSchoolId,
      toDesignationId: this.transferOrder.toDesignationId,
      orderDate: this.datePipe.transform(this.transferOrder.orderDate, 'dd-MM-yyyy'),
      orderNo: this.transferOrder.orderNo,
      remark: this.transferOrder.remark,
      remark1: this.transferOrder.remark1,
      transferCategoryId: this.transferOrder.transferCategoryId
    });
  }

  save() {
    if (this.transferOrderForm.valid) {
      this.loading = true;
      this.transferOrder = Object.assign({}, this.transferOrderForm.value);
      if (this.id) {
        this.service.update(this.id, this.transferOrder).subscribe(() => {
          this.toastrService.success('transfer order updated successful');
          this.router.navigate(['/management/transfer-orders']);
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
      else {
        this.service.create(this.transferOrder).subscribe(() => {
          this.toastrService.success('transfer order created successful');
          this.router.navigate(['/management/transfer-orders']);
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
    }
  }

  delete() {
    if (!confirm('Are you sure you want to delete this transfer order?')) return;

    this.service.delete(this.id).subscribe(() => {
      this.toastrService.success('transfer order deleted successful');
      this.router.navigate(['/management/transfer-orders']);
    });
  }




}
